<div class="baseball-scorer">
  <h2>Live game</h2>

  @if (current(); as state) {
    <div class="counter">
      <span class="value">{{ state.pitches }}</span>
      <span class="label">pitches</span>
    </div>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="recordPitch()">Record pitch</button>
      <button mat-stroked-button (click)="stop()">End appearance</button>
    </div>

    @if (restWarning(); as warn) {
      <p class="warn">{{ warn }}</p>
    }
  } @else {
    <button mat-flat-button color="primary" (click)="startDemo()">Start pitcher</button>
  }
</div>
